import React from 'react';
import { Avatar } from '../pages/AppLayout';

export default function PresenceIndicator({ viewers = [], typingUsers = [] }) {
  if (viewers.length === 0 && typingUsers.length === 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto' }}>
      {viewers.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {viewers.map((u, i) => (
            <div key={u.id} style={{ marginLeft: i > 0 ? -10 : 0, zIndex: viewers.length - i, position: 'relative', border: '2px solid #fff', borderRadius: '50%' }}>
              <Avatar user={u} size={28} showStatus={true} />
            </div>
          ))}
          <span style={{ fontSize: 12, color: 'var(--trello-text-muted)', marginLeft: 8 }}>viewing</span>
        </div>
      )}
      
      {typingUsers.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'rgba(0,121,191,0.1)', padding: '4px 10px', borderRadius: 999 }}>
          <div className="tm-loader" style={{ width: 12, height: 12, border: '2px solid transparent', borderTopColor: 'var(--trello-blue)' }}></div>
          <span style={{ fontSize: 11, color: 'var(--trello-blue)', fontWeight: 600 }}>
            {typingUsers.length === 1 ? 'someone is typing...' : 'multiple people typing...'}
          </span>
        </div>
      )}
    </div>
  );
}
